<div class="executive-wrapper">

    <div class="row g-4 mb-5">
        <div class="col-12 col-md-6 col-xl-4"
            v-for="kpi in executive_kpis"
            :key="kpi.title">

            <div class="card rounded-4 shadow-lg h-100 border-0"
                :class="kpi.borderClass">

            <div class="card-body p-4">

                <!-- ICON -->
                <div class="d-flex align-items-center gap-3 mb-2">
                <div class="rounded-3 d-flex align-items-center justify-content-center"
                    style="width:48px; height:48px; background:#f6f7fb;">
                    <i :class="kpi.icon" class="fs-4 text-dark"></i>
                </div>

                <h6 class="fw-bold text-uppercase mb-0 text-muted small">
                    {{ kpi.title }}
                </h6>
                </div>

                <!-- VALUE -->
                <div class="display-6 fw-bold mb-2">{{ kpi.value }}</div>

                <!-- CHANGE -->
                <div class="d-flex align-items-center mb-2">
                <span 
                    :class="kpi.change_status === 'positive'
                        ? 'text-success fw-semibold'
                        : 'text-danger fw-semibold'"
                    class="me-2">
                    {{ kpi.change }}
                </span>

                <span class="text-muted small">{{ kpi.subtext }}</span>
                </div>

                <!-- FOOTER TEXT -->
                <p class="text-muted small mb-0">
                {{ kpi.footer }}
                </p>

            </div>
            </div>

        </div>
    </div>

    <div class="row g-4 mb-4">

    <!-- LEFT: Customer Growth -->
    <div class="col-12 col-lg-6">
        <div class="card border-0 rounded-4 shadow-lg p-4 h-100">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="fw-semibold mb-0">Customer Growth & Cohort Analysis</h4>
            <a class="text-warning fw-semibold small cursor-pointer">Detailed View →</a>
        </div>

        <div id="customerGrowthChart" style="height: 350px;"></div>
        </div>
    </div>

    <!-- RIGHT: Team Radar Chart -->
    <div class="col-12 col-lg-6">
        <div class="card border-0 rounded-4 shadow-lg p-4 h-100">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="fw-semibold mb-0">Team Efficiency Metrics</h4>
            <a class="text-warning fw-semibold small cursor-pointer">Team Analytics →</a>
        </div>

        <div id="teamRadarChart" style="height: 350px;"></div>
        </div>
    </div>

    </div>


    <div class="row g-4 mb-4">

    <!-- LEFT: Strategic Initiatives -->
    <div class="col-12 col-lg-6">
        <div class="card border-0 rounded-4 shadow-lg p-4 h-100">
        <h5 class="fw-semibold mb-3 text-center">Strategic Initiatives (2025)</h5>

        <div v-for="initiative in initiatives" :key="initiative.title" class="mb-4">

            <div class="d-flex align-items-center gap-3 mb-2">
            <div 
                class="rounded-circle d-flex align-items-center justify-content-center"
                :style="{width:'40px', height:'40px', background: initiative.iconBg}"
            >
                <i :class="initiative.icon" class="fs-5"></i>
            </div>

            <div>
                <h6 class="fw-bold mb-1">{{ initiative.title }}</h6>
                <p class="text-muted small mb-1">{{ initiative.subtitle }}</p>
            </div>
            </div>

            <div class="progress" style="height:6px;">
            <div class="progress-bar" :style="{width: initiative.progress + '%', background: initiative.progressColor}"></div>
            </div>

        </div>
        </div>
    </div>

    <!-- RIGHT: Risk Dashboard -->
    <div class="col-12 col-lg-6">
        <div class="card border-0 rounded-4 shadow-lg p-4 h-100">
        <h5 class="fw-semibold mb-3 text-center">Risk Dashboard</h5>

        <div
            v-for="risk in risks"
            :key="risk.title"
            class="p-3 rounded-4 mb-3"
            :class="risk.cardClass"
        >
            <div class="d-flex justify-content-between align-items-start">
            <h6 class="fw-bold">{{ risk.title }}</h6>
            <span class="badge rounded-pill px-3" :class="risk.badgeClass">{{ risk.level }}</span>
            </div>

            <p class="small text-muted mb-0">
            {{ risk.description }}
            </p>
        </div>

        </div>
    </div>

    </div>

    <div class="card border-0 rounded-4 shadow-lg p-4 mb-4">

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="fw-semibold">Recommended Executive Actions</h4>
      <p class="text-muted small mb-0">Priority interventions based on current performance data</p>
    </div>

    <button class="btn upload-button px-4 py-2 rounded-pill fw-semibold">
      SCHEDULE BOARD MEETING
    </button>
  </div>

  <div class="row g-4 mt-2">

    <!-- ACTION CARD -->
    <div class="col-12 col-lg-4" v-for="action in actions" :key="action.title">
      <div class="p-4 rounded-4 h-100 shadow-sm"
           :style="{ background: action.bg, borderLeft: '6px solid ' + action.border }">

        <h6 class="fw-bold text-uppercase mb-2" :style="{ color: action.border }">
          {{ action.timeline }}
        </h6>

        <h5 class="fw-bold mb-2">{{ action.title }}</h5>

        <p class="text-muted small mb-0">{{ action.description }}</p>

      </div>
    </div>

  </div>
</div>


  </div>